import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useAuth } from './useAuth';

export function useIntercom() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Initialize Intercom with user data
      Intercom({
        app_id: 'i4codill',
        user_id: user.id,
        name: user.user_metadata?.full_name || user.email?.split('@')[0] || 'User',
        email: user.email || '',
        created_at: Math.floor(new Date(user.created_at).getTime() / 1000), // Convert to Unix timestamp in seconds
      });
    } else {
      // Boot Intercom for anonymous users
      Intercom({
        app_id: 'i4codill',
      });
    }

    // Cleanup function to shutdown Intercom when component unmounts
    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [user]);

  // Update Intercom when user data changes
  useEffect(() => {
    if (user && window.Intercom) {
      window.Intercom('update', {
        user_id: user.id,
        name: user.user_metadata?.full_name || user.email?.split('@')[0] || 'User',
        email: user.email || '',
        created_at: Math.floor(new Date(user.created_at).getTime() / 1000),
      });
    }
  }, [user]);
}